import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question:
      "¿SAINT® es una opción para la depresión resistente a la medicación?",
    answer:
      "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  },
];

export const esTmsVsMedicationForDepression = makeEsArticle({
  slug: "tms-vs-medication-for-depression",
  title: "TMS frente a medicación para la depresión resistente",
  description:
    "Comparación de TMS/SAINT® y los antidepresivos cuando la medicación no ha funcionado lo suficiente para el trastorno depresivo mayor.",
  h1: "TMS frente a medicación para la depresión",
  breadcrumbLabel: "TMS vs medicación para la depresión",
  shortAnswer:
    "Cuando los antidepresivos no han funcionado lo suficiente, la TMS y SAINT® son opciones autorizadas por la FDA para el trastorno depresivo mayor. SAINT® es una TMS acelerada con orientación por fMRI, administrada en cinco días, indicada para adultos que no han mejorado con antidepresivos. La TMS no reemplaza la medicación; el enfoque para cada persona se evalúa en una consulta con el equipo clínico.",
  keyTakeaways: [
    "TMS y SAINT® están autorizadas por la FDA para el trastorno depresivo mayor.",
    "SAINT® está indicada para adultos que no han mejorado con antidepresivos.",
    "SAINT® se administra en cinco días con orientación por fMRI.",
    "La TMS no reemplaza la medicación.",
    "El enfoque se evalúa en una consulta.",
  ],
  sections: [
    {
      heading: "Cuando la medicación no ha funcionado",
      paragraphs: [
        "Para algunas personas, los antidepresivos no producen una mejoría suficiente. En esos casos, la TMS y SAINT® son opciones autorizadas por la FDA. SAINT® está indicada específicamente para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos.",
      ],
    },
    {
      heading: "Diferencia con la TMS convencional",
      paragraphs: [
        "La TMS convencional dura unas seis semanas con una sesión diaria. SAINT® comprime 50 sesiones en cinco días con orientación individualizada por fMRI y patrón theta burst. La TMS convencional suele estar cubierta por los seguros; SAINT® suele ser de pago directo y el pago directo puede oscilar entre $25,000 y $28,000. Verificamos los beneficios sin costo, sea cual sea su aseguradora. La cobertura varía según el plan.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "Cole EJ, et al. Stanford Accelerated Intelligent Neuromodulation Therapy for Treatment-Resistant Depression. Am J Psychiatry. 2020;177(8):716-726.",
      url: "https://doi.org/10.1176/appi.ajp.2019.19070720",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
